import { InjectionToken } from '@angular/core';
import { Db } from 'angular-in-memory-web-api';

export const FAKE_DB_COLLECTIONS_TOKEN = new InjectionToken<Db>('FAKE_DB_COLLECTION');
